import styled from 'styled-components'
import Flex from '../Flex/Flex'

const MaxWidthWrapper = styled(Flex).attrs({
  justifyContent: 'space-between',
})`
  width: 100%;
  max-width: 80vw;
  margin: 0 10vw;
`
export default MaxWidthWrapper
